export type MarketplacePostingNudgeType = "load" | "lorry";

/** Nudge cards shown on load marketplace (truckers + shippers). */
export const LOAD_MARKETPLACE_POSTING_NUDGE_TYPES = ["lorry", "load"] as MarketplacePostingNudgeType[];

/** Nudge card shown on lorry marketplace (shippers). */
export const LORRY_MARKETPLACE_POSTING_NUDGE_TYPES = ["load"] as MarketplacePostingNudgeType[];

export const MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX = 5;
export const MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX = 1;

export const MARKETPLACE_POSTING_NUDGE_CONTENT: Record<
    MarketplacePostingNudgeType,
    {
        image: { src: string; width: number; height: number };
        label: string;
        cta: string;
    }
> = {
    load: {
        image: { src: "/load-icons/v1/Load.png", width: 70, height: 77 },
        label: "Post your load to get matching lorries",
        cta: "Post Load"
    },
    lorry: {
        image: { src: "/lorry-icons/v3/Container.png", width: 156, height: 74 },
        label: "Add your lorry to get matching loads",
        cta: "Post Lorry"
    }
};

export function getMarketplacePostingNudgeIndex(isMobileScreen: boolean) {
    return isMobileScreen ? MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX : MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX;
}

export function getMarketplaceNudgePlacement(cardCount: number, index: number, nudgeIndex: number) {
    const isNudgePositionLast = cardCount > 0 && cardCount <= nudgeIndex && cardCount === index + 1;
    const isNudgeSlot = index === nudgeIndex || isNudgePositionLast;

    return {
        isNudgeSlot,
        showBefore: isNudgeSlot && !isNudgePositionLast,
        showAfter: isNudgeSlot && isNudgePositionLast
    };
}
